import _toConsumableArray from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { isFieldDef } from '../../channeldef';
import { pathGroupingFields } from '../../encoding';
import { isImputeSequence } from '../../transform';
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var ImputeNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(ImputeNode, _DataFlowNode);

  function ImputeNode(parent, transform) {
    var _this;

    _classCallCheck(this, ImputeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImputeNode).call(this, parent));
    _this.transform = transform;
    return _this;
  }

  _createClass(ImputeNode, [{
    key: "clone",
    value: function clone() {
      return new ImputeNode(null, duplicate(this.transform));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set([this.transform.impute]);
    }
  }, {
    key: "processSequence",
    value: function processSequence(keyvals) {
      var _keyvals$start = keyvals.start,
          start = _keyvals$start === void 0 ? 0 : _keyvals$start,
          stop = keyvals.stop,
          step = keyvals.step;
      var result = [start, stop].concat(_toConsumableArray(step ? [step] : [])).join(',');
      return {
        signal: "sequence(".concat(result, ")")
      };
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Impute ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform = this.transform,
          impute = _this$transform.impute,
          key = _this$transform.key,
          keyvals = _this$transform.keyvals,
          method = _this$transform.method,
          groupby = _this$transform.groupby,
          value = _this$transform.value,
          _this$transform$frame = _this$transform.frame,
          frame = _this$transform$frame === void 0 ? [null, null] : _this$transform$frame;
      var initialImpute = Object.assign({
        type: 'impute',
        field: impute,
        key: key
      }, keyvals ? {
        keyvals: isImputeSequence(keyvals) ? this.processSequence(keyvals) : keyvals
      } : {}, {
        method: 'value'
      }, groupby ? {
        groupby: groupby
      } : {}, {
        value: null
      });
      var setImputedField;

      if (method && method !== 'value') {
        var deriveNewField = Object.assign({
          type: 'window',
          as: ["imputed_".concat(impute, "_value")],
          ops: [method],
          fields: [impute],
          frame: frame,
          ignorePeers: false
        }, groupby ? {
          groupby: groupby
        } : {});
        var replaceOriginal = {
          type: 'formula',
          expr: "datum.".concat(impute, " === null ? datum.imputed_").concat(impute, "_value : datum.").concat(impute),
          as: impute
        };
        setImputedField = [deriveNewField, replaceOriginal];
      } else {
        var replaceWithValue = {
          type: 'formula',
          expr: "datum.".concat(impute, " === null ? ").concat(value, " : datum.").concat(impute),
          as: impute
        };
        setImputedField = [replaceWithValue];
      }

      return [initialImpute].concat(_toConsumableArray(setImputedField));
    }
  }], [{
    key: "makeFromTransform",
    value: function makeFromTransform(parent, imputeTransform) {
      return new ImputeNode(parent, imputeTransform);
    }
  }, {
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var encoding = model.encoding;
      var xDef = encoding.x;
      var yDef = encoding.y;

      if (isFieldDef(xDef) && isFieldDef(yDef)) {
        var imputedChannel = xDef.impute ? xDef : yDef.impute ? yDef : undefined;

        if (imputedChannel === undefined) {
          return undefined;
        }

        var keyChannel = xDef.impute ? yDef : yDef.impute ? xDef : undefined;
        var _imputedChannel$imput = imputedChannel.impute,
            method = _imputedChannel$imput.method,
            value = _imputedChannel$imput.value,
            frame = _imputedChannel$imput.frame,
            keyvals = _imputedChannel$imput.keyvals;
        var groupbyFields = pathGroupingFields(model.mark, encoding);
        return new ImputeNode(parent, Object.assign({
          impute: imputedChannel.field,
          key: keyChannel.field
        }, method ? {
          method: method
        } : {}, value !== undefined ? {
          value: value
        } : {}, frame ? {
          frame: frame
        } : {}, keyvals !== undefined ? {
          keyvals: keyvals
        } : {}, groupbyFields.length ? {
          groupby: groupbyFields
        } : {}));
      }

      return null;
    }
  }]);

  return ImputeNode;
}(DataFlowNode);